import { executeGet, executePost, api, resCode } from "./Network";

const pickAuthUrl = (response) => {
  const raw =
    response?.authUrl ||
    response?.auth_url ||
    response?.data?.authUrl ||
    response?.data?.auth_url ||
    null;
  if (typeof raw !== "string") return null;
  const url = raw.trim();
  return url.startsWith("http") ? url : null;
};

/**
 * Wajib akses process.env.* secara STATIS.
 * Webpack/Metro hanya meng-inline nama key yang tertulis langsung,
 * bukan process.env[variable] / template string.
 */
const readEnv = (...keys) => {
  for (const value of keys) {
    if (typeof value === "string" && value.trim()) {
      return value.trim();
    }
  }
  return null;
};

/**
 * Sementara: kredensial dari FE .env (nanti diganti API).
 * Electron tidak menyimpan / tidak membaca .env untuk Google.
 */
export const getGoogleDesktopConfigFromFe = () => ({
  googleClientId: readEnv(
    process.env.EXPO_PUBLIC_GOOGLE_DESKTOP_CLIENT_ID,
    process.env.GOOGLE_DESKTOP_CLIENT_ID,
  ),
  googleClientSecret: readEnv(
    process.env.EXPO_PUBLIC_GOOGLE_DESKTOP_CLIENT_SECRET,
    process.env.GOOGLE_DESKTOP_CLIENT_SECRET,
  ),
  jwtKey: readEnv(
    process.env.EXPO_PUBLIC_KUBUKU_JWT_KEY,
    process.env.KUBUKU_JWT_KEY,
  ),
});

export const requestSosmedLogin = async () => {
  const response = await executeGet(api.sosmedLoginReq);
  if (response.code !== resCode.ok) {
    throw new Error(response.msg || "Gagal memulai login Google");
  }
  return response;
};

/** Ambil authUrl dari response BE bila sudah tersedia. */
export const getGoogleAuthUrl = (response) => pickAuthUrl(response);

export const verifySosmedLogin = async (email, fullname, jwtToken) => {
  const formData = new FormData();
  formData.append("email", email);
  formData.append("nama", fullname);
  formData.append("token", jwtToken);
  formData.append("channel", "GOOGLE");
  const response = await executePost(api.sosmedLoginCheck, formData);
  if (response.code !== resCode.ok || !response.data) {
    throw new Error(response.msg || "Gagal login dengan Google");
  }
  return response;
};

/** Tukar code dari deep link BE (fase API). */
export const exchangeGoogleCode = async (code) => {
  const formData = new FormData();
  formData.append("code", code);
  formData.append("channel", "GOOGLE");
  const response = await executePost(api.sosmedLoginCheck, formData);
  if (response.code !== resCode.ok || !response.data) {
    throw new Error(response.msg || "Gagal menukar kode Google");
  }
  return response;
};
